const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_ERROR = 'LOGIN_ERROR'
const LOGOUT = 'LOGOUT'
const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'

const RESET_COMPANY_FLAGS = 'RESET_COMPANY_FLAGS'

const SET_HAS_SMS = 'SET_HAS_SMS'
const SET_HAS_PACKING_LIST = 'SET_HAS_PACKING_LIST'
const SET_HAS_CRITICAL_LINES = 'SET_HAS_CRITICAL_LINES'
const SET_HAS_TASKS = 'SET_HAS_TASKS'

const SET_IS_TRW = 'SET_IS_TRW'
const SET_LANG_PT = 'SET_LANG_PT'

const SET_HAS_REPEAT_EXPEDITION = 'SET_HAS_REPEAT_EXPEDITION'
const SET_HAS_REPEAT_RECEPTION = 'SET_HAS_REPEAT_RECEPTION'

const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY'

export default {
  namespaced: true,
  state: {
    deploymentEnvironment: localStorage.getItem('deploymentEnvironment'),
    user: localStorage.getItem('user'),
    authenticated: !!localStorage.getItem('token') || !!localStorage.getItem('tokenJwt'),
    token: localStorage.getItem('token'),
    tokenJwt: localStorage.getItem('tokenJwt'),
    refresh: localStorage.getItem('refresh'),
    company: localStorage.getItem('company') ? Number(localStorage.getItem('company')) : null,
    currentCompany: null,
    fetchCompanyPromise: null,
    fetchUserPromise: null,
    userData: {},

    // Roles & Prohibitions
    admin: { id: 5, prohibitions: ['lockdowns'] },
    office: { id: 1, prohibitions: ['createMasters'] },
    warehouseResp: { id: 2, prohibitions: ['createMasters', 'seeHistory', 'seeTasklist'] },
    forklift: { id: 6, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'addTruck', 'editTruck', 'seeHistory', 'justCompanyNotes', 'isForkLift', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    kiosk: { id: 4, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'seeFilters', 'isKiosk', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    client: { id: 3, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'addTruck', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    truckAccess: { id: 10, prohibitions: ['createMasters', 'addExp', 'addRecep', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'seeFilters', 'editTruck', 'editExp', 'editRecep', 'deleteRecep', 'seeTasklist'] },
    truckAccessTrw: { id: 14, prohibitions: ['createMasters', 'addExp', 'addRecep', 'seeHistory', 'editStatus', 'editReasons', 'justClientNotes', 'seeFilters', 'editTruck', 'editExp', 'editRecep', 'deleteExp', 'deleteRecep', 'seeTasklist'] },

    ReadOnly: { id: 11, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'isKiosk', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist', 'seeTrucks', 'seeBi', 'seeCriticalLines'] },
    guardia: { id: 10, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'editExp', 'editRecep', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist', 'seeDashboard', 'seeExpeditions', 'seeReceptions', 'seeBi'] },
    carretilleros: { id: 9, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addRecep', 'addTruck', 'editTruck', 'seeHistory', 'onlyTruckHours', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    oficinaJuanCarlos: { id: 8, prohibitions: ['createMasters', 'addTruck', 'editTruck'] },
    plannerTrw: { id: 7, prohibitions: ['lockdowns', 'createMasters', 'deleteExp', 'deleteRecep', 'addTruck', 'editTruck', 'mrpLimitations', 'seeTasklist', 'seeDashboard', 'seeTrucks', 'seeBi'] },
    kioskReceptions: { id: 13, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addRecep', 'addTruck', 'editExp', 'editRecep', 'editTruck', 'seeFilters', 'isKiosk', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'seeTasklist'] },
    provider: { id: 12, prohibitions: ['lockdowns', 'createMasters', 'addExp', 'addCL', 'addTruck', 'editExp', 'editTruck', 'seeOriginFilter', 'seeHistory', 'editStatus', 'editReasons', 'deleteExp', 'deleteRecep', 'repeatReceptions', 'repeatExpedition', 'seeTasklist', 'seeDashboard', 'seeExpeditions', 'seeTrucks', 'seeBi'] }
  },
  mutations: {
    [LOGIN] (state) {
      state.do_login = true
    },
    [LOGIN_SUCCESS] (state) {
      state.authenticated = true
      state.do_login = false
    },
    [LOGIN_ERROR] (state) {
      state.do_login = false
    },
    [LOGOUT] (state) {
      state.authenticated = false
    },
    [CHANGE_PASSWORD] (state) {
      state.do_change_password = true
    },
    [CHANGE_PASSWORD_SUCCESS] (state) {
      state.do_change_password = false
    },
    [CHANGE_PASSWORD_ERROR] (state) {
      state.do_change_password = false
    },

    [SET_CURRENT_COMPANY] (state, company) {
      state.currentCompany = company
    },

    [SET_HAS_SMS] (state, hasSms) {
      state.hasSms = hasSms
    },
    [SET_HAS_PACKING_LIST] (state, hasPackingList) {
      state.hasPackingList = hasPackingList
    },

    [SET_HAS_CRITICAL_LINES] (state, hasCriticalLines) {
      state.hasCriticalLines = hasCriticalLines
    },

    [SET_HAS_TASKS] (state, hasTasks) {
      state.hasTasks = hasTasks
    },

    [SET_LANG_PT] (state, langPt) {
      state.langPt = langPt
    },
    [SET_IS_TRW] (state, isTrw) {
      state.isTrw = isTrw
    },

    [SET_HAS_REPEAT_EXPEDITION] (state, hasRepeatExpedition) {
      state.hasRepeatExpedition = hasRepeatExpedition
    },
    [SET_HAS_REPEAT_RECEPTION] (state, hasRepeatReception) {
      state.hasRepeatReception = hasRepeatReception
    },

    [RESET_COMPANY_FLAGS] (state) {
      state.hasSms = false
      state.hasPackingList = false
      state.hasCriticalLines = false
      state.hasTasks = false

      state.isTrw = false
      state.langPt = false

      state.hasRepeatReception = false
      state.hasRepeatExpedition = false
    }
  },
  actions: {
    login ({ commit, state, getters, rootState, dispatch }, creds) {
      return dispatch('request', { method: 'post', url: 'get-token', data: creds }, { root: true })
        .then(
          response => {
            localStorage.setItem('user', creds.username)
            state.user = creds.username
            localStorage.setItem('token', response.data.token)
            state.token = response.data.token
            commit(LOGIN_SUCCESS)
            return dispatch('user').then(() => {
              return dispatch('fetchCompany')
            }).then(() => response)
          }
        ).catch(error => {
          commit(LOGIN_ERROR)
          throw error
        })
    },
    setJwtToken ({ commit, state, getters, rootState }, creds) {
      state.tokenJwt = creds.tokenJwt
      state.refresh = creds.refresh
      state.authenticated = true
    },
    setCompany ({ commit, state, dispatch }, newCompany) {
      state.company = newCompany
      state.currentCompany = null

      localStorage.setItem('company', state.company)
      return dispatch('fetchCompany').then((company) => {
        return company
      })
    },
    logout ({ commit, state }) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('tokenJwt')
      localStorage.removeItem('refresh')
      localStorage.removeItem('group')
      localStorage.removeItem('company')
      localStorage.removeItem('deploymentEnvironment')
      state.deploymentEnvironment = null
      state.userData = {}
      commit(LOGOUT)
      return Promise.resolve()
    },
    changePassword ({ commit, state, getters, rootState, dispatch }, oldNew1New2Passwd) {
      commit(CHANGE_PASSWORD)
      return dispatch('request', { method: 'post', url: `api/user/${state.userData.user.id}/change_password`, data: oldNew1New2Passwd }, { root: true })
        .then(
          response => {
            rootState.notification = {
              group: 'global',
              duration: 4000,
              type: 'success',
              title: 'Change password',
              text: 'Sucessfully saved new password'
            }
            commit(CHANGE_PASSWORD_SUCCESS)
            return response
          }
        ).catch(error => {
          // commit(CHANGE_PASSWORD_ERROR)
          throw error
        })
    },
    logoutSso ({ commit, state, dispatch }) {
      if (state.authenticated) {
        return dispatch('request', { method: 'get', url: 'sso/logout' }, { root: true })
          .then(
            response => {
              return response
            }
          ).catch(error => {
            throw error
          })
      }
    },
    refreshSso ({ commit, state, getters, rootState, dispatch }, creds) {
      if (state.authenticated) {
        return dispatch('request', { method: 'post', url: 'jwt/refresh-token', data: creds }, { root: true })
          .then(
            response => {
              if (response === 'token_not_valid') {
                state.authenticated = false
                state.tokenJwt = ''
                state.refresh = ''
                localStorage.setItem('tokenJwt', '')
                localStorage.setItem('refresh', '')
                return 'token_not_valid'
              }
              localStorage.setItem('refresh', response.data.refresh)
              state.refresh = response.data.refresh
              localStorage.setItem('tokenJwt', response.data.access)
              state.tokenJwt = response.data.access
            }
          ).catch(error => {
            throw error
          })
      }
    },
    user ({ commit, state, dispatch }) {
      if (state.fetchUserPromise) return state.fetchUserPromise
      if (!state.authenticated) return Promise.resolve(null)
      state.fetchUserPromise = dispatch('request', { method: 'get', url: 'api/user/auth' }, { root: true })
        .then(response => {
          if (response === 'token_not_valid') {
            state.authenticated = false
            state.tokenJwt = ''
            state.refresh = ''
            localStorage.setItem('tokenJwt', '')
            localStorage.setItem('refresh', '')
            return 'token_not_valid'
          }
          response.data.clients = response.data.clients.map(x => x.id)
          state.userData = response.data
          state.deploymentEnvironment = process.env.DEPLOYMENT_ENVIRONMENT
          localStorage.setItem('deploymentEnvironment', state.deploymentEnvironment)
          if (!localStorage.getItem('company') && state.userData.user) {
            state.company = state.userData.user.groups[0].id
            localStorage.setItem('company', state.company)
          }
          state.fetchUserPromise = null
          return response.data
        }).catch(error => {
          dispatch('logout').then(() => { this.$router.push('/login') })
          state.fetchUserPromise = null
          throw error
        })
      return state.fetchUserPromise
    },
    fetchCompany ({ commit, state, dispatch }) {
      if (state.fetchCompanyPromise) return state.fetchCompanyPromise

      if (!state.company) {
        commit('RESET_COMPANY_FLAGS')
        return Promise.resolve(null)
      }

      if (state.currentCompany && state.company === state.currentCompany.id) {
        return Promise.resolve(state.currentCompany)
      }

      state.fetchCompanyPromise = dispatch('companies/read', state.company, { root: true })
        .then(company => {
          commit('SET_HAS_SMS', !!company.has_sms || false)
          commit('SET_HAS_PACKING_LIST', !!company.has_packing_list || false)
          commit('SET_HAS_CRITICAL_LINES', !!company.has_critical_lines || false)
          commit('SET_HAS_TASKS', !!company.has_tasks || false)

          commit('SET_IS_TRW', !!company.is_trw || false)
          commit('SET_LANG_PT', !!company.lang_pt || false)

          commit('SET_HAS_REPEAT_EXPEDITION', !!company.has_expeditions_rrule || false)
          commit('SET_HAS_REPEAT_RECEPTION', !!company.has_receptions_rrule || false)

          commit('SET_CURRENT_COMPANY', company)
          state.fetchCompanyPromise = null
          return company
        })
        .catch(error => {
          commit('RESET_COMPANY_FLAGS')
          state.fetchCompanyPromise = null
          throw error
        })

      return state.fetchCompanyPromise
    },
    checkPermissions ({ getters, state, dispatch }, actionsRequired) {
      if (!Array.isArray(actionsRequired)) actionsRequired = [actionsRequired]

      return dispatch('fetchCompany').then(() => {
        const prohibitions = new Map(getters.permisionCollection.map(x => [x.id, x.prohibitions]))
        const results = {}

        const checkRoles = (roles) => {
          actionsRequired.forEach(action => {
            if (state.deploymentEnvironment === 'trw-pro' && action.startsWith('delete')) {
              results[action] = roles.some(rol => rol.id === state.admin.id)
              return
            }
            const legacyAction = action === 'deleteTruck' ? 'editTruck' : action
            results[action] = roles.every(rol => {
              const prohibitionsForRole = prohibitions.get(rol.id)
              return prohibitionsForRole && !prohibitionsForRole.includes(legacyAction)
            })
          })
        }

        if (state.userData.roles) {
          checkRoles(state.userData.roles)
          return results
        } else {
          return dispatch('user').then(() => {
            if (state.userData.roles) {
              checkRoles(state.userData.roles)
            } else {
              actionsRequired.forEach(action => (results[action] = false))
            }
            return results
          })
        }
      })
    }
  },
  getters: {
    permisionCollection (state) {
      const roles = {
        admin: state.admin,
        office: state.office,
        warehouseResp: state.warehouseResp,
        forklift: state.forklift,
        kiosk: state.kiosk,
        client: state.client,
        truckAccess: state.isTrw ? state.truckAccessTrw : state.truckAccess,
        guardia: state.guardia,
        carretilleros: state.carretilleros,
        oficinaJuanCarlos: state.oficinaJuanCarlos,
        plannerTrw: state.plannerTrw,
        kioskReceptions: state.kioskReceptions,
        provider: state.provider,
        ReadOnly: state.ReadOnly
      }
      return Object.values(roles)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js